<template>
  <div class="slideshow">
    <div class="content" :key="image">
      <img :src="image" />
    </div>
  </div>
</template>

<script>
const kSwitchTime = 2000;

export default {
  name: "Welcome",

  data() {
    const images = ["/assets/venue-0.png"];

    return { image: images[0], images: images, interval: null, index: 0 };
  },

  mounted() {
    this.interval = setInterval(() => {
      this.index += 1;

      if (this.index < this.images.length) {
        this.image = this.images[this.index];
      } else {
        if (this.interval) {
          clearInterval(this.interval);
        }

        this.$router.replace({ name: "Talks" });
      }
    }, kSwitchTime);
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
};
</script>

<style scoped></style>
